/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculateProrateRequest } from '../models/CalculateProrateRequest';
import type { ProrateCalculationResponse } from '../models/ProrateCalculationResponse';
import type { StaffPayrollRecordDto } from '../models/StaffPayrollRecordDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProrateCalculatorControllerService {
  /**
   * calculateProrate
   * @returns ProrateCalculationResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static calculateProrateUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CalculateProrateRequest;
  }): CancelablePromise<ProrateCalculationResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/prorate/calculate',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * applyProrateToStaffRecord
   * @returns StaffPayrollRecordDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static applyProrateToStaffRecordUsingPost({
    reason,
    staffRecordId,
    startDate,
  }: {
    /**
     * reason
     */
    reason: 'DEPARTURE' | 'NEW_HIRE';
    /**
     * staffRecordId
     */
    staffRecordId: string;
    /**
     * startDate
     */
    startDate: string;
  }): CancelablePromise<StaffPayrollRecordDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/prorate/staff-record/{staffRecordId}/apply',
      path: {
        staffRecordId: staffRecordId,
      },
      query: {
        reason: reason,
        startDate: startDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
